import { Navigate, Outlet, useOutletContext } from 'react-router-dom';

import { useAuthStore } from '@/stores/authStore';
import { hasLegacyKanbanAccess } from '@/utils/legacyAccess';

// Fecha o gap de acesso direto por URL: esconder o item de navegação não
// impede alguém de digitar /app/legacy-orders diretamente.
export const LegacyOnlyRoute = () => {
  const user = useAuthStore((state) => state.user);
  // Esse componente fica entre o <Outlet> do AppLayout e as páginas de
  // Dashboard/Orders — sem repassar o context aqui, useOutletContext() nessas
  // páginas resolve contra o Outlet DESTE componente (sem context nenhum) em
  // vez do Outlet do AppLayout, e a desestruturação de openEditOrderModal
  // quebra com "Cannot destructure property... of undefined".
  const context = useOutletContext();

  if (!hasLegacyKanbanAccess(user)) {
    return <Navigate to="/app/leads" replace />;
  }

  return <Outlet context={context} />;
};
